export default __webpack_public_path__ + "static/media/dj_working.91abc295.png";